/* c8 ignore start */
export const ENVIRONMENT = {
  // CI testing
  TEST: 'test',

  // deployment
  DEVELOPMENT: 'dev',
  STAGING: 'staging',
  DDE_SIMULATION: 'dde-sims',
  PRODUCTION: 'production'
} as const

export type Environment = ValueOf<typeof ENVIRONMENT>

// srarena deployments build with modes like 'production-srarena'; strip the suffix so that
// environment-based logic keeps matching the canonical environment (imgarena and srarena builds
// share the same logical env, they only differ by the VITE_* hosts in their env file).
export const APP_ENV = ((import.meta.env?.MODE || process.env.NODE_ENV) as string)?.replace(
  /-srarena$/,
  ''
) as Environment

export const DEV_ENV = APP_ENV === ENVIRONMENT.DEVELOPMENT || APP_ENV === ENVIRONMENT.TEST
